import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ComponentExplorerLayout } from '../components/ComponentExplorerLayout';
import { ComponentExplorerSidebar } from '../components/ComponentExplorerSidebar';
import { ComponentExplorerContent } from '../components/ComponentExplorerContent';
import { getShowcaseById } from '../showcases';
import { useShowcase } from '../hooks/useShowcase';
import type { PropDefinition } from '../showcases/types';

const EMPTY_PROPS: PropDefinition[] = [];

export function ComponentExplorerPage() {
  const { componentId } = useParams<{ componentId: string }>();
  const [isDarkMode, setIsDarkMode] = useState(false);

  const showcase = componentId ? getShowcaseById(componentId) : undefined;
  const { playgroundProps, setPlaygroundProps, resetProps } = useShowcase(
    showcase?.propsDefinition ?? EMPTY_PROPS
  );

  const handleToggleDarkMode = () => {
    setIsDarkMode((prev) => !prev);
  };

  return (
    <ComponentExplorerLayout
      sidebar={
        <ComponentExplorerSidebar
          currentId={componentId}
        />
      }
      isDarkMode={isDarkMode}
      onToggleDarkMode={handleToggleDarkMode}
      componentId={componentId}
    >
      <ComponentExplorerContent
        showcase={showcase}
        playgroundProps={playgroundProps}
        isDarkMode={isDarkMode}
        onPropsChange={setPlaygroundProps}
        onPropsReset={resetProps}
      />
    </ComponentExplorerLayout>
  );
}
